import { createAction } from '@reduxjs/toolkit'
import { LiteracyResultType } from 'src/store/user/assessment_literacy/reducer';

export const userAssessmentLiteracySetResult = createAction<LiteracyResultType>('USER_ASSESSMENT_LITERACY_SET_RESULT')
